<template>
  <div>
    <Head title="Create Organization" />
    {{loading}}
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/templates">Hisobotlar turi</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/2" label="title" />
        </div>
        <div class="w-full -mb-8 h-64 -mr-6 p-8">
          <editor
            v-model="form.content"
            lineheight_formats = "8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 36pt"
            api-key="jzoa1aw0fxv9b966j8jyirek6o6v55dma4c9nrm2expy30ug"
            :init="{

              plugins: 'advlist autolink  lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste',
              toolbar: 'undo redo | styleselect | forecolor | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | link image | code'
            }"
          />
        </div>


        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Organization</loading-button>
        </div>
      </form>
    </div>
    <button @click="generatePdf()" class="btn-indigo">Get Pdf</button>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

import Editor from '@tinymce/tinymce-vue'


import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';
pdfMake.fonts = {
  'Roboto' : {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-Italic.ttf'
  },

  'OpenSans' : {
    normal: 'OpenSans-Regular.ttf',
    bold: 'OpenSans-Medium.ttf',
    italics: 'OpenSans-Italic.ttf',
    bolditalics: 'OpenSans-Italic.ttf'
  }

}


export default {
  components: {
    Head: Head,
    Link: Link,
    LoadingButton: LoadingButton,
    TextInput: TextInput,
    'editor': Editor
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      editor: 'some starter message',
      loading: true,
      form: this.$inertia.form({
        title: null,
        content: 'some starter message',

      }),
    }
  },
  methods: {
    store() {
      this.form.post('/templates')
    },
    generatePdf(){

      //html to pdf format
      var html = htmlToPdfmake(this.form.content);
      const documentDefinition = { content: html };

      pdfMake.createPdf(documentDefinition).open();
    },
  },

}

</script>
